<template>
  <div class="store-locator-component">
    <div class="store-locator">
      <div class="row no-gutters">
        <div class="col-12 col-lg-6">
          <div class="container mt-5">
            <div class="store-search-form">
              <div class="row">
                <div class="col-12">
                  <h2>Store Locator</h2>
                  <p class="mt-4">
                    Find the nearest <br />
                    Dutche Chocolates
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="input-group mt-3">
                    <input
                      type="text"
                      name="address"
                      class="form-control"
                      v-model="address"
                      @keyup="searchLocation"
                      placeholder="Type in address keyword here"
                      aria-describedby="inputGroupPrepend"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="button" @click="reset">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="store-search-results">
            <div v-show="stores === null" class="no-result">
              <div class="no-result-message font-weight-bold">
                Oops! We couldn't find a Dutche Chocolates store near you.
              </div>
              <div class="mt-3">Please search again.</div>
            </div>
            <div class="search-results mt-5">
              <div
                class="result-item"
                v-for="(store, index) in stores"
                :key="index"
              >
                <div
                  class="store-details"
                  @click="toggleInfoWindow(store, index)"
                >
                  <div class="store-name font-weight-bold">
                    <span class="store-label">{{ store.label }}</span> -
                    {{ store.name }}
                  </div>
                  <div class="store-address">
                    {{ store.address }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="map-responsive">
            <GmapMap
              :center="centerMap"
              :zoom="zoomMap"
              map-type-id="roadmap"
              style="width: 100%; height: 810px"
            >
              <gmap-info-window
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen = false"
              />
              <GmapMarker
                :key="index"
                v-for="(store, index) in stores"
                :position="store.position"
                :label="store.label"
                @click="toggleInfoWindow(store, index)"
              />
            </GmapMap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "StoreLocator",
  data() {
    return {
      address: undefined,
      stores: undefined,
      centerMap: { lat: 14.5953295, lng: 121.0281903 },
      zoomMap: 12,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMarkerIndex: null,
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },
  methods: {
    searchLocation() {
      if (this.address === undefined || this.address.length < 4) {
        return;
      }

      axios.get(`/search-store?address=${this.address}`).then(response => {
        if (!response.data.success) {
          this.stores = null;
        } else {
          this.stores = response.data.stores;
        }
      });
    },
    toggleInfoWindow(marker, index) {
      this.infoWindowPos = marker.position;
      this.infoOptions.content = marker.name;

      if (this.currentMarkerIndex == index) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMarkerIndex = index;
        this.centerMap = marker.position;
        this.zoomMap = 14;
      }
    },
    reset() {
      this.address = '';
      this.stores = undefined;
    }
  }
};
</script>

<style lang="sass" scoped>
.store-search-form
  text-align: center

  h2
    font-size: 2.5em
    font-family: "Might Could"

  p
    color: $dutche-primary-yellow
    font-weight: bold

  .form-control
    height: 3rem
    border-top: 1px solid $dutche-primary-violet
    border-bottom: 1px solid $dutche-primary-violet
    border-left: 1px solid $dutche-primary-violet
    border-right: none
    border-top-left-radius: 0.8em
    border-bottom-left-radius: 0.8em
    text-transform: uppercase

  ::placeholder
    text-transform: uppercase

  .input-group-append
    border-top: 1px solid $dutche-primary-violet
    border-bottom: 1px solid $dutche-primary-violet
    border-right: 1px solid $dutche-primary-violet
    border-left: none
    border-top-right-radius: 0.8em
    border-bottom-right-radius: 0.8em

    button
      border: none
      color: $dutche-primary-violet

.store-search-results
  height: 600px
  overflow-y: scroll
  overflow-x: hidden
  scrollbar-color: $dutche-primary-violet
  scrollbar-width: thin

  .result-item
    padding: 2rem
    border-top: 1px solid $dutche-primary-violet
    height: 150px
    margin: 0 auto

  .result-item:last-child
    border-bottom: 1px solid $dutche-primary-violet

  .no-result
    padding: 1rem

  .no-result-message
    font-size: 1.25em

  .store-details
    cursor: pointer

    .store-name
      font-size: 1.25em

    .store-label
      color: $dutche-primary-brown

    .store-address
      font-size: 1em

@media(min-width: 992px)
  .store-search-form
    text-align: left
    padding: 0 3rem

    h2
      font-size: 3em
  
  .store-search-results
    height: 550px

    .result-item
      padding: 2rem 4rem

    .no-result
      padding: 2rem 4rem
</style>
